import {createApp} from 'vue'
import App from './App.vue'

import "bootstrap"
import BootstrapVue3, {BreadcrumbPlugin} from 'bootstrap-vue-3'

import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import "bootstrap/dist/css/bootstrap.min.css"

import router from "./router";
import store from "./store/index";

import {dom, library} from "@fortawesome/fontawesome-svg-core";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons';
import {far} from '@fortawesome/free-regular-svg-icons';

import './assets/admin.css'
import './assets/style.css'

import VueNumberFormat from 'vue-number-format'
import VueSweetAlert from 'vue-sweetalert2'
import axios from "axios";
import $store from './store'
import Notifications, {notify} from '@kyvg/vue3-notification'
import VueDatePicker from '@vuepic/vue-datepicker';

library.add(fas);
library.add(fab);
library.add(far);
dom.watch();

// Add a request interceptor
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    $store.dispatch('loader/start');
    return config;
}, function (error) {
    // Do something with request error
    $store.dispatch('loader/end');
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Do something with response data
    $store.dispatch('loader/end');
    return response;
}, function (e) {
    // Do something with response error
    $store.dispatch('loader/end');
    if (e.response) {
        /*console.log("Message",e.response.data.message);*/
        console.log("Message", e.response);
        if (e.response.status === 401 || e.response.status === 403) {
            if (e.response.data.code == 996) {
                notify({
                    type: 'error',
                    title: 'Error',
                    text: e.response.data.message || e.message,
                });
            } else {
                localStorage.clear();
                router.push('/');
                if ($store.state.auth.checked) {
                    notify({
                        type: 'error',
                        title: 'Error',
                        text: e.response.data.error || e.message,
                    });
                }
                // sessionStorage.clear();
            }

        }
    }
    return Promise.reject(e)
});

createApp(App)
    .component("font-awesome-icon", FontAwesomeIcon)
    .use(router)
    .use(store)
    .use(BootstrapVue3)
    .use(BreadcrumbPlugin)
    .use(VueNumberFormat, {prefix: '', decimal: '.', thousand: ',', precision: 2})
    .use(Notifications)
    .use(VueDatePicker)
    .use(VueSweetAlert)
    .mount('#app')
